import React from "react";
import VisitorsDetail from "./view/VisitorsDetail";
import { VisitorsDetailContextProvider } from "./VisitorsDetailView";
import VisitorsContent from "../../constants/contentFile.json";

const VisitorsDetailPage = () => {
  return (
    <VisitorsDetailContextProvider>
      <VisitorsDetail textContent={VisitorsContent.visitorDetails} />
    </VisitorsDetailContextProvider>
  );
};

export default VisitorsDetailPage;
